import { createAddAccount, updateAddAccount } from '@/API/repositories/meta';
import { SPEND_SOURCES } from '@/common/constants/spend_sources';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef, useState } from 'react';

const useAddAccountForm = ({ setShow, account, metaAccounts }) => {
	const { options } = useCommonDataContext();
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const { marketsOptions, productsOptions } = options;

	const metaAccountsOptions = metaAccounts.map((account) => ({
		label: account.email,
		value: account._id,
	}));

	const nameRef = useRef();
	const addAccountIdRef = useRef();
	const isActiveRef = useRef();

	const [metaAccount, setMetaAccount] = useState(
		metaAccountsOptions.find((opt) => opt.value === account.meta_account),
	);
	const [marketId, setMarketId] = useState(
		marketsOptions.find((opt) => opt.value === account?.market),
	);
	const [productId, setProductId] = useState(
		productsOptions.find((opt) => opt.value === account?.product),
	);
	const [source, setSource] = useState(
		SPEND_SOURCES.find((opt) => opt.value === account?.source),
	);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const payload = {
			meta_account: metaAccount.value,
			source: source.value,
			name: nameRef.current.value,
			add_account_id: addAccountIdRef.current.value,
			market: marketId.value,
			product: productId.value,
			is_active: isActiveRef.current.checked,
		};

		const response =
			Object.keys(account).length > 0
				? await makeRequest(updateAddAccount.bind(null, payload, account._id))
				: await makeRequest(createAddAccount.bind(null, payload));

		if (response?.data) {
			setShow(() => false);
			return addMessage('Saved', 'success');
		}

		addMessage('Something went wrong!', 'error');
	};

	return {
		handleSubmit,
		metaAccountsOptions,
		setMetaAccount,
		metaAccount,
		marketsOptions,
		setMarketId,
		marketId,
		productsOptions,
		setProductId,
		productId,
		nameRef,
		addAccountIdRef,
		isActiveRef,
		source,
		setSource,
	};
};

export default useAddAccountForm;
